(function () {
  const elementName = 'fa-shadow-delivery';
  if (customElements.get(elementName)) return;

  class ShadowDelivery extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.config = this.readConfig();
      this.status = this.querySelector('[data-fa-shadow-delivery-status]');
      if (!this.config || !this.status) return;

      if (!this.config.available) {
        this.setStatus(this.translate('byAvailability'));
        return;
      }
      if (!this.config.endpoint) {
        this.setStatus(this.translate('deliveryUnavailable'));
        return;
      }

      this.requestEstimate();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    readConfig() {
      const script = this.querySelector('[data-fa-shadow-delivery-config]');
      if (!script) return null;
      try {
        return JSON.parse(script.textContent || '{}');
      } catch {
        return null;
      }
    }

    translate(key) {
      return String(this.config?.i18n?.[key] || '');
    }

    setStatus(value) {
      this.status.textContent = String(value || '');
    }

    async requestEstimate() {
      this.setStatus(this.translate('calculating'));
      const controller = new AbortController();
      this.controller = controller;
      const timeout = window.setTimeout(() => controller.abort(), 10000);

      try {
        const response = await fetch(this.config.endpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          signal: controller.signal,
          body: JSON.stringify({
            locale: this.config.locale || document.documentElement.lang || 'de',
            sku: this.config.sku || '',
            thicknessCm: Number(this.config.thicknessCm || 2),
            productGroup: this.config.productGroup || '',
            inventoryQuantity: Number(this.config.inventoryQuantity || 0),
          }),
        });
        const payload = await response.json().catch(() => ({}));
        if (!response.ok || !payload.ok) throw new Error(payload.message || 'Delivery estimate failed');
        this.setStatus(
          String(payload.estimate?.deliveryText || '').trim() || this.translate('byAvailability'),
        );
      } catch {
        this.setStatus(this.translate('deliveryReload'));
      } finally {
        window.clearTimeout(timeout);
        if (this.controller === controller) this.controller = null;
      }
    }
  }

  customElements.define(elementName, ShadowDelivery);
})();
